export const ZMG_TOAST_CHANNEL = "ZMG_TOAST_CHANNEL";
export interface BroadcastChannelToastTypes {
    type: "success" | "error" | "warning" | "info" | "dismiss" | "message";
    message: string;
    description?: string;
}

